<template>
<span v-if="remedial">        
       
        <p>
            <label>Created From <span class="w3-text-red">(required)</span></label>
            <businesses-links-list required type="rights" v-model="remedial.createdfrombusiness" />
        </p>

        <span v-if="remedial.createAs==='linkedremedial'">        
          <p>
            <label>Job/Remedial#</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="remedial.jobnumber"/>            
          </p>
          
          <p>
            <label >Requested by <span class="w3-text-red">(required)</span></label>
            <businesses-links-list required type="linked" v-model="remedial.linkedbusiness" />
          </p>  

        </span>

        <p>
            <label>PO/Reference #</label>
            <input type="text" class="w3-input w3-border" style="resize:none" v-model="remedial.referencenumber"/>            
        </p> 

        <span v-if="remedial.createAs==='lodgedremedial'">        
          
      
          <p>          
            <span v-if="!remedial.id">
              <label >Lodge with <span class="w3-text-red">(required)</span></label>
              <businesses-links-list class="w3-input w3-border w3-panel w3-border w3-border-red" required type="lodge" v-model="remedial.linkedbusiness" />
            </span>  
          </p>  
        </span>        
         

        <!-- <p>
          <label>Task</label>
          <input type="text" class="w3-input w3-border" style="resize:none" v-model="remedial.task"/>            
        </p>   -->
        <p>
          <label >Contact/Address</label>          
          <textarea rows="3" class="w3-input w3-border" style="resize:none" v-model="remedial.address"/>              
        </p>

        <p>
          <label >Issue <span class="w3-text-red">(required)</span></label>
          <textarea rows="3" required class="w3-input w3-border w3-panel w3-border w3-border-red" style="resize:none" v-model="remedial.issue"/>            
        </p> 
        
        
        <slot></slot>        
     
  </span>

</template>

<script>
  export default {    
    props: ["remedial"]    
  }
</script>
 


// WEBPACK FOOTER //
// src/components/shared/controls/layouts/RemedialNewLayout.vue